import { combineReducers } from 'redux';
import authState from './auth';
import clientState from './client';
import itemState from './item';
import adminState from './admin';

import { reducer as tr } from 'react-redux-toastr';
export default combineReducers({ authState, clientState, toastr: tr, itemState, adminState });
